<button mat-icon-button [matMenuTriggerFor]="languageMenu" class="language-btn">
  <img [src]="getFlagPath(currentFlag())" class="language-flag" [alt]="currentLanguage()" />
  <span class="language-code">{{ currentLanguage().toUpperCase() }}</span>
</button>

<mat-menu #languageMenu="matMenu">
  @for (language of languages; track language.code) {
    <button
      mat-menu-item
      (click)="changeLanguage(language.code)"
      [class.active]="currentLanguage() === language.code">
      <img [src]="getFlagPath(language.flag)" class="language-flag-menu" [alt]="language.label" />
      <span>{{ language.label }}</span>
    </button>
  }
</mat-menu>
